// extracted by mini-css-extract-plugin
module.exports = {"page":"src-v5-pages-HomePage-styles-style-module__page--23TQx"};